import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef7ed406"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "summary-label"
}
const _hoisted_2 = { class: "summary-rows" }

import { themingCssClass } from "../../mixins/theming-mixin";
  import { recProps } from '../../mixins/rec-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-count-summary',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["components__rec-count-summary", [_unref(themingCssClass)('normal')]])
  }, [
    (_ctx.description.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.description.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.rows, (row) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: row.label
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["summary-row--label", { 'summary-row--black': row.black }])
          }, _toDisplayString(row.label), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["summary-row--value", { 'summary-row--black': row.black }])
          }, _toDisplayString(row.value), 3)
        ], 64))
      }), 128))
    ])
  ], 2))
}
}

})